import React from 'react';
import { CContainer, CButton } from '@coreui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import ShipmentTable from '../../components/ShipmentTable/ShipmentTable';
import './Shipment.scss';

const Shipment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateShipment = () => {
    navigate('/shipments/create');
  };

  return (
    <div className="shipment-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('shipments')}</div>
        <ShipmentTable />
      </CContainer>
      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateShipment}
        title={t('createShipment')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

export default Shipment; 